"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5000,7364],{

/***/ 45000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Listing_Map; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useDebounce.ts
var useDebounce = __webpack_require__(4841);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
;// CONCATENATED MODULE: ./components/Listing/Map/drawStyle.ts
var DrawStyle = function() {
    return [
        // ACTIVE (being drawn)
        // line stroke
        {
            id: "gl-draw-line",
            type: "line",
            filter: [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "!=",
                    "mode",
                    "static"
                ]
            ],
            layout: {
                "line-cap": "round",
                "line-join": "round"
            },
            paint: {
                "line-color": "#28666e",
                "line-width": 2
            }
        },
        // polygon fill
        {
            id: "gl-draw-polygon-fill",
            type: "fill",
            filter: [
                "all",
                [
                    "==",
                    "$type",
                    "Polygon"
                ],
                [
                    "!=",
                    "mode",
                    "static"
                ]
            ],
            paint: {
                "fill-color": "#000",
                "fill-outline-color": "#000",
                "fill-opacity": 0.1
            }
        },
        // polygon mid points
        {
            id: "gl-draw-polygon-midpoint",
            type: "circle",
            filter: [
                "all",
                [
                    "==",
                    "$type",
                    "Point"
                ],
                [
                    "==",
                    "meta",
                    "midpoint"
                ]
            ],
            paint: {
                "circle-radius": 3,
                "circle-color": "#fbb03b"
            }
        },
        // polygon outline stroke
        {
            id: "gl-draw-polygon-stroke-active",
            type: "line",
            filter: [
                "all",
                [
                    "==",
                    "$type",
                    "Polygon"
                ],
                [
                    "!=",
                    "mode",
                    "static"
                ]
            ],
            layout: {
                "line-cap": "round",
                "line-join": "round"
            },
            paint: {
                "line-color": "#000",
                "line-width": 2
            }
        },
        // vertex point halos
        {
            id: "gl-draw-polygon-and-line-vertex-halo-active",
            type: "circle",
            filter: [
                "all",
                [
                    "==",
                    "meta",
                    "vertex"
                ],
                [
                    "==",
                    "$type",
                    "Point"
                ],
                [
                    "!=",
                    "mode",
                    "static"
                ], 
            ],
            paint: {
                "circle-radius": 5,
                "circle-color": "#FFF"
            }
        },
        // vertex points
        {
            id: "gl-draw-polygon-and-line-vertex-active",
            type: "circle",
            filter: [
                "all",
                [
                    "==",
                    "meta",
                    "vertex"
                ],
                [
                    "==",
                    "$type",
                    "Point"
                ],
                [
                    "!=",
                    "mode",
                    "static"
                ], 
            ],
            paint: {
                "circle-radius": 5,
                "circle-color": "#000"
            }
        },
        // INACTIVE (static, already drawn)
        // line stroke
        {
            id: "gl-draw-line-static",
            type: "line",
            filter: [
                "all",
                [
                    "==",
                    "$type",
                    "LineString"
                ],
                [
                    "==",
                    "mode",
                    "static"
                ]
            ],
            layout: {
                "line-cap": "round",
                "line-join": "round"
            },
            paint: {
                "line-color": "#000",
                "line-width": 3
            }
        },
        // polygon fill
        {
            id: "gl-draw-polygon-fill-static",
            type: "fill",
            filter: [
                "all",
                [
                    "==",
                    "$type",
                    "Polygon"
                ],
                [
                    "==",
                    "mode",
                    "static"
                ]
            ],
            paint: {
                "fill-color": "#000",
                "fill-outline-color": "#000",
                "fill-opacity": 0.1
            }
        },
        // polygon outline
        {
            id: "gl-draw-polygon-stroke-static",
            type: "line",
            filter: [
                "all",
                [
                    "==",
                    "$type",
                    "Polygon"
                ],
                [
                    "==",
                    "mode",
                    "static"
                ]
            ],
            layout: {
                "line-cap": "round",
                "line-join": "round"
            },
            paint: {
                "line-color": "#000",
                "line-width": 3
            }
        }, 
    ];
};
/* harmony default export */ var drawStyle = (DrawStyle);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./utils/apiClient.ts
var apiClient = __webpack_require__(77364);
;// CONCATENATED MODULE: ./utils/popupDetail.ts




var popupDetail = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(slug) {
        var res;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apiClient/* apiClient.get */.x.get("/api/v1/rets/".concat(slug, "?fields=BedroomsTotal,ParkingTotal,BathroomsTotalInteger,UnparsedAddress,Municipality,ListingKey,ListPrice,Slug,Lock"))
                    ];
                case 1:
                    res = _state.sent();
                    if (res.ok) {
                        return [
                            2,
                            (0,_object_spread/* default */.Z)({
                                Image: "https://api.bungalowfinder.ca/cdn/images/".concat(res.data.Ml_num, "/photo_1.webp")
                            }, res.data)
                        ];
                    }
                    return [
                        2,
                        {
                            notFound: true,
                            props: {}
                        }
                    ];
            }
        });
    });
    return function popupDetail(slug) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var utils_popupDetail = (popupDetail);

;// CONCATENATED MODULE: ./components/Listing/Map/index.tsx











var MapGL = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2634), __webpack_require__.e(9441)]).then(__webpack_require__.bind(__webpack_require__, 79441)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79441)
            ];
        }
    }
});
var NavigationControl = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2634), __webpack_require__.e(9441)]).then(__webpack_require__.bind(__webpack_require__, 79441)).then(function(mod) {
        return mod.NavigationControl;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79441)
            ];
        }
    }
});
var Source = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2634), __webpack_require__.e(9441)]).then(__webpack_require__.bind(__webpack_require__, 79441)).then(function(mod) {
        return mod.Source;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79441)
            ];
        }
    }
});
var Layer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2634), __webpack_require__.e(9441)]).then(__webpack_require__.bind(__webpack_require__, 79441)).then(function(mod) {
        return mod.Layer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79441)
            ];
        }
    }
});
var Draw = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2634), __webpack_require__.e(9441), __webpack_require__.e(7836)]).then(__webpack_require__.bind(__webpack_require__, 27836));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27836)
            ];
        }
    }
});
var Cluster = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2634), __webpack_require__.e(9441), __webpack_require__.e(4131)]).then(__webpack_require__.bind(__webpack_require__, 64131));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64131)
            ];
        }
    }
});
var Marker = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2634), __webpack_require__.e(9441)]).then(__webpack_require__.bind(__webpack_require__, 79441)).then(function(mod) {
        return mod.Marker;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79441)
            ];
        }
    }
});
var ClearBoundary = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7666).then(__webpack_require__.bind(__webpack_require__, 57666));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57666)
            ];
        }
    },
    suspense: true
});
var ClusterMarker = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3866).then(__webpack_require__.bind(__webpack_require__, 3866));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3866)
            ];
        }
    },
    suspense: true
});
var Popup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1040), __webpack_require__.e(2882), __webpack_require__.e(3391)]).then(__webpack_require__.bind(__webpack_require__, 29731));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29731)
            ];
        }
    },
    suspense: true
});
var Map = function(param) {
    var mapLine = param.mapLine, mapListing = param.mapListing, queries = param.queries, query = param.query;
    var clusterRef = (0,react.useRef)(undefined);
    var ref = (0,react.useState)({
        latitude: mapLine.center.lat,
        longitude: mapLine.center.lng,
        zoom: mapLine.zoom
    }), viewPort = ref[0], setViewPort = ref[1];
    var ref1 = (0,react.useState)(), popup = ref1[0], setPopup = ref1[1];
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    (0,react.useEffect)(function() {
        setViewPort({
            latitude: mapLine.center.lat,
            longitude: mapLine.center.lng,
            zoom: mapLine.zoom
        });
    }, [
        mapLine
    ]);
    var onClusterClick = function(cluster) {
        try {
            var superCluster = clusterRef.current.getCluster();
            var zoom = superCluster.getClusterExpansionZoom(cluster.clusterId);
            setViewPort((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, viewPort), {
                longitude: cluster.longitude,
                latitude: cluster.latitude,
                zoom: zoom
            }));
        } catch (error) {}
    };
    var _onMapMove = function(e) {
        var _box = e.target.getBounds();
        queries.push({
            box: [
                _box._ne.lng,
                _box._ne.lat,
                _box._sw.lng,
                _box._sw.lat
            ],
            page: 1
        });
    };
    var onMoveMap = (0,useDebounce/* default */.Z)(_onMapMove, 500);
    var onDraw = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var polygon;
            return (0,tslib_es6.__generator)(this, function(_state) {
                polygon = e.features[0].geometry.coordinates[0];
                queries.push({
                    box: undefined,
                    polygon: JSON.stringify(polygon)
                });
                return [
                    2
                ];
            });
        });
        return function onDraw(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapGL, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query.box && query.box.length > 1 && {
                bounds: query.box
            }), {
                onMoveend: onMoveMap,
                onViewportChange: function() {},
                boxZoom: true,
                scrollZoom: true,
                className: "w-full h-full",
                mapStyle: "mapbox://styles/imatteh/cl2hglt9i000z14o6u14se0pl",
                accessToken: "pk.eyJ1IjoiaW1hdHRlaCIsImEiOiJja3J2dTZqamEwYTZpMnZsanUxcWhrcW9jIn0.c3dQrAz3T8LQNnfvP3z_Wg"
            }), viewPort), {
                children: [
                    query.clear !== "true" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Source, {
                                id: "boundaries",
                                type: "geojson",
                                data: mapLine.polygon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layer, {
                                id: "boundaries",
                                type: "line",
                                source: "boundaries",
                                paint: {
                                    "line-color": "#28666E",
                                    "line-width": 3
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Cluster, {
                        radius: 50,
                        extend: 150,
                        ref: clusterRef,
                        nodeSize: 36,
                        component: function(prop) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClusterMarker, {
                                    onClick: onClusterClick,
                                    latitude: prop.latitude,
                                    longitude: prop.longitude,
                                    pointCount: prop.pointCount
                                })
                            });
                        },
                        children: mapListing.bboxPolygon ? mapListing.bboxPolygon.map(function(m, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                                latitude: m.Lat,
                                longitude: m.Lng,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                        var res;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        utils_popupDetail(m.slug)
                                                    ];
                                                case 1:
                                                    res = _state.sent();
                                                    setPopup(res);
                                                    setOpen(true);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }),
                                    className: "relative inline-block cursor-pointer select-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "flex justify-center items-center gap-1 hover:scale-150 bg-green-800 hover:bg-green-600 transition-all duration-100 text-white text-center rounded-md p-2 absolute font-normal after:absolute after:top-full after:left-1/2 after:ml-[-5px] after:border-solid after:border-4 after:border-t-primary after:border-b-transparent after:border-x-transparent",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaHome */.xng, {}),
                                            " ",
                                            Intl.NumberFormat("en-US", {
                                                notation: "compact",
                                                maximumFractionDigits: 2
                                            }).format(m.ListPrice)
                                        ]
                                    })
                                })
                            }, index);
                        }) : mapListing.bboxList.map(function(m, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                                latitude: m.Lat,
                                longitude: m.Lng,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                        var res;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        utils_popupDetail(m.slug)
                                                    ];
                                                case 1:
                                                    res = _state.sent();
                                                    setPopup(res);
                                                    setOpen(true);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }),
                                    className: "relative inline-block cursor-pointer select-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "flex justify-center items-center gap-1 hover:scale-150 bg-green-800 hover:bg-green-600 transition-all duration-100 text-white text-center rounded-md p-2 absolute font-normal after:absolute after:top-full after:left-1/2 after:ml-[-5px] after:border-solid after:border-4 after:border-t-primary after:border-b-transparent after:border-x-transparent",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaHome */.xng, {}),
                                            " ",
                                            Intl.NumberFormat("en-US", {
                                                notation: "compact",
                                                maximumFractionDigits: 2
                                            }).format(m.ListPrice)
                                        ]
                                    })
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Draw, {
                        // @ts-ignore
                        styles: drawStyle(),
                        pointControl: false,
                        displayControlsDefault: false,
                        lineStringControl: false,
                        uncombineFeaturesControl: false,
                        combineFeaturesControl: false,
                        onDrawCreate: onDraw,
                        onDrawUpdate: onDraw,
                        onDrawDelete: function() {
                            queries.push({
                                polygon: undefined
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearBoundary, {
                            queries: queries,
                            query: query
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationControl, {
                        position: "top-left"
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup, {
                modalopen: open,
                item: popup,
                handleModalClose: function() {
                    setOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var Listing_Map = (Map);


/***/ }),

/***/ 77364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ apiClient; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50196);

var apiClient = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "https://api.bungalowfinder.ca"
});
// export const apiClient = axios.create({
//   baseURL: "http://127.0.0.1:2000",
// });
apiClient.interceptors.request.use(function(config) {
    var token = localStorage.getItem("token");
    if (!token) return config;
    if (config.headers) {
        config.headers["Authorization"] = "Bearer ".concat(token);
    }
    return config;
}, function(error) {
    return Promise.reject(error);
});
apiClient.interceptors.response.use(function(res) {
    var _res = {
        ok: true,
        data: res.data,
        status: res.status
    };
    return _res;
}, function(error) {
    var res = undefined;
    if (error.response) {
        var _message = [];
        _message.push(error.response.data.message);
        res = {
            status: error.response.status,
            error: "SERVER",
            message: _message,
            data: error.response.data,
            ok: false
        };
        if (res.status === 401) {
            localStorage.removeItem("token");
            window.dispatchEvent(new CustomEvent("unauth"));
        }
        return Promise.resolve(res);
    }
    if (error.request) {
        res = {
            status: 500,
            data: error.request,
            error: "CLIENT",
            message: error.message,
            ok: false
        };
        return Promise.resolve(res);
    }
    res = {
        status: 500,
        data: {},
        ok: false,
        error: "ANY",
        message: [
            "Internal Server Error"
        ]
    };
    return Promise.resolve(res);
});


/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ })

}]);